import React, { useState } from 'react';
import { ShieldCheck, Lock, CreditCard, RotateCcw } from 'lucide-react';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState('completo');
  return <section id="compra" className="w-full bg-[#111111] py-16 px-4 flex flex-col items-center font-sans" data-id="element-72">
      <div className="max-w-2xl w-full" data-id="element-73">
        <div className="text-center mb-8" data-id="element-74">
          <h2 className="text-xl md:text-2xl font-bold text-white flex items-center justify-center gap-2" data-id="element-75">
            👉 Elegí tu plan y dale a COMPRAR AHORA 👇
          </h2>
        </div>

        <div className="space-y-4" data-id="element-76">
          {/* Plan Básico */}
          <div onClick={() => setSelectedPlan('basico')} className={`cursor-pointer rounded-2xl p-5 border-2 transition-all duration-300 ${selectedPlan === 'basico' ? 'border-gray-400 bg-[#1A1A1A]' : 'border-gray-800 bg-[#161616] hover:border-gray-700'}`} data-id="element-77">
            <div className="flex items-start justify-between" data-id="element-78">
              <div className="flex items-start gap-4" data-id="element-79">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'basico' ? 'border-white' : 'border-gray-500'}`} data-id="element-80">
                  {selectedPlan === 'basico' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-81" />}
                </div>
                <div data-id="element-82">
                  <h3 className="text-xl font-bold text-white flex items-center gap-2" data-id="element-83">
                    📘 PACK BÁSICO
                  </h3>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-84">
                    5 tomos + 3 bonos + 30 menús
                  </p>

                  {/* Expandable Content */}
                  <div className={`overflow-hidden transition-all duration-300 ease-in-out ${selectedPlan === 'basico' ? 'max-h-40 opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-85">
                    <ul className="space-y-1.5 text-sm text-gray-300" data-id="element-86">
                      <li className="flex items-center gap-2" data-id="element-87">
                        <div className="w-2 h-2 bg-blue-400 rounded-sm" data-id="element-88"></div>{' '}
                        Tomo 1 y 2
                      </li>
                      <li className="flex items-center gap-2" data-id="element-89">
                        <div className="w-2 h-2 bg-green-400 rounded-sm" data-id="element-90"></div>{' '}
                        Tomo 3 y 4
                      </li>
                      <li className="flex items-center gap-2" data-id="element-91">
                        <div className="w-2 h-2 bg-orange-400 rounded-sm" data-id="element-92"></div>{' '}
                        Tomo 5
                      </li>
                      <li className="flex items-center gap-2" data-id="element-93">
                        <div className="w-2 h-2 bg-red-400 rounded-sm" data-id="element-94"></div> 3
                        Bonos Exclusivos
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="text-right shrink-0" data-id="element-95">
                <p className="text-gray-500 line-through text-xs md:text-sm" data-id="element-96">
                  $69.990
                </p>
                <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-97">
                  $19.990
                </p>
              </div>
            </div>
          </div>

          {/* Plan Completo (Best Value) */}
          <div onClick={() => setSelectedPlan('completo')} className={`cursor-pointer rounded-2xl p-5 border-2 transition-all duration-300 ${selectedPlan === 'completo' ? 'border-yellow-500 bg-[#1A1A1A] shadow-[0_0_15px_rgba(234,179,8,0.15)]' : 'border-gray-800 bg-[#161616] hover:border-gray-700'}`} data-id="element-98">
            <div className="flex items-start justify-between" data-id="element-99">
              <div className="flex items-start gap-4" data-id="element-100">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'completo' ? 'border-yellow-500' : 'border-gray-500'}`} data-id="element-101">
                  {selectedPlan === 'completo' && <div className="w-2.5 h-2.5 rounded-full bg-yellow-500" data-id="element-102" />}
                </div>
                <div data-id="element-103">
                  <h3 className="text-xl font-bold text-yellow-500 flex items-center gap-2" data-id="element-104">
                    🏆 PACK COMPLETO
                  </h3>
                  <div className="flex gap-2 mt-2 mb-1" data-id="element-105">
                    <span className="bg-yellow-500 text-black text-[10px] md:text-xs px-2 py-0.5 rounded font-bold uppercase tracking-wide" data-id="element-106">
                      MÁS ELEGIDO
                    </span>
                    <span className="border border-yellow-500 text-yellow-500 text-[10px] md:text-xs px-2 py-0.5 rounded font-bold uppercase tracking-wide" data-id="element-107">
                      MEJOR VALOR
                    </span>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-108">
                    PACK BASICO +{' '}
                    <span className="bg-yellow-500 text-black px-1.5 py-0.5 rounded font-bold" data-id="element-109">
                      LONCHERA KIDS ESCOLAR + FREEZER INTELIGENTE SIN TACC
                    </span>
                  </p>

                  {/* Expandable Content */}
                  <div className={`overflow-hidden transition-all duration-300 ease-in-out ${selectedPlan === 'completo' ? 'max-h-64 opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-110">
                    <ul className="space-y-1.5 text-sm text-gray-300" data-id="element-111">
                      <li className="flex items-center gap-2" data-id="element-112">
                        <div className="w-2 h-2 bg-blue-400 rounded-sm" data-id="element-113"></div>{' '}
                        Tomo 1 y 2
                      </li>
                      <li className="flex items-center gap-2" data-id="element-114">
                        <div className="w-2 h-2 bg-green-400 rounded-sm" data-id="element-115"></div>{' '}
                        Tomo 3 y 4
                      </li>
                      <li className="flex items-center gap-2" data-id="element-116">
                        <div className="w-2 h-2 bg-orange-400 rounded-sm" data-id="element-117"></div>{' '}
                        Tomo 5
                      </li>
                      <li className="flex items-center gap-2" data-id="element-118">
                        <div className="w-2 h-2 bg-red-400 rounded-sm" data-id="element-119"></div> 3
                        Bonos Exclusivos
                      </li>
                      <li className="flex items-center gap-2 mt-2" data-id="element-120">
                        <div className="w-2 h-2 bg-purple-400 rounded-sm" data-id="element-121"></div>{' '}
                        LONCHERA KIDS ESCOLAR
                      </li>
                      <li className="flex items-center gap-2" data-id="element-122">
                        <div className="w-2 h-2 bg-white rounded-sm" data-id="element-123"></div>{' '}
                        FREEZER INTELIGENTE SIN TACC
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="text-right shrink-0" data-id="element-124">
                <p className="text-gray-500 line-through text-xs md:text-sm" data-id="element-125">
                  $108.980
                </p>
                <p className="text-2xl md:text-3xl font-bold text-yellow-500" data-id="element-126">
                  $29.990
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Social Proof Banner */}
        <div className="mt-6 bg-[#1A1A1A] border-l-4 border-yellow-500 p-4 rounded-r-lg flex items-start gap-3" data-id="element-127">
          <span className="text-xl" data-id="element-128">🔥</span>
          <p className="text-gray-300 text-sm md:text-base" data-id="element-129">
            El <strong data-id="element-130">80% de nuestros clientes</strong> elige el Pack Completo.
            Es el que más valor tiene por su precio.
          </p>
        </div>

        {/* Buy Button */}
        <div className="mt-8" data-id="element-131">
          <a href={selectedPlan === 'basico' ? 'https://checkout.impulsodigitalx.shop/cart/45858009350305:1' : 'https://checkout.impulsodigitalx.shop/cart/45858012266657:1'} className="w-full block text-center bg-[#E52B2B] hover:bg-[#D42424] text-white font-black text-xl md:text-2xl py-4 px-8 rounded-xl shadow-[0_4px_20px_rgba(229,43,43,0.4)] transform hover:-translate-y-1 transition-all duration-300 uppercase tracking-wide" data-id="element-132">
            COMPRAR AHORA
          </a>

          {/* Trust Badges */}
          <div className="mt-6 flex flex-wrap justify-center gap-6 text-gray-500" data-id="element-133">
            <div className="flex flex-col items-center gap-1" data-id="element-134">
              <Lock size={24} data-id="element-135" />
              <span className="text-[10px] uppercase font-bold" data-id="element-136">
                Pago Seguro
              </span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-137">
              <RotateCcw size={24} data-id="element-138" />
              <span className="text-[10px] uppercase font-bold" data-id="element-139">
                Garantía 7 Días
              </span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-140">
              <CreditCard size={24} data-id="element-141" />
              <span className="text-[10px] uppercase font-bold" data-id="element-142">
                Tarjetas / Efectivo
              </span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-143">
              <ShieldCheck size={24} data-id="element-144" />
              <span className="text-[10px] uppercase font-bold" data-id="element-145">
                Privacidad
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}